import { parse, stringify } from 'query-string';
import { useCallback } from 'react';
import { stringifyDateRange } from 'components/organisms/projects-report/common/range-picker/transformer';
import { DateRange } from 'components/organisms/projects-report/common/range-picker/types';
import { useLocalStorage } from 'hooks/use-local-storage';

export const useNextQueryParam = (): {
  getNextQueryParam: (range: DateRange) => `?${string}`;
} => {
  const [query] = useLocalStorage('timesheets_report.overall_filter', '');

  const getNextQueryParam = useCallback(
    (range: DateRange) =>
      `?${stringify({
        ...parse(query),
        range: stringifyDateRange(range),
      })}` as `?${string}`,
    [query],
  );

  return {
    getNextQueryParam,
  };
};
